import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React, { forwardRef, memo, useImperativeHandle, useMemo, useState } from 'react';
import Popover from '@material-ui/core/Popover';
import { bindHover, bindPopover, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import HoverPopover from 'material-ui-popup-state/HoverPopover';
import classNames from 'classnames';
import useStyles from './styles';
import Button from '../Button';
var Popup = /*#__PURE__*/forwardRef(function (props, ref) {
  var hide = props.hide,
      children = props.children,
      buttonProps = props.buttonProps,
      label = props.label,
      hover = props.hover,
      popupState = props.popupState,
      button = props.button,
      getContextMenu = props.getContextMenu,
      className = props.className,
      fullWidth = props.fullWidth,
      rest = _objectWithoutPropertiesLoose(props, ["hide", "children", "buttonProps", "label", "hover", "popupState", "button", "getContextMenu", "className", "fullWidth"]);

  var classes = useStyles();
  var popupId = useMemo(function () {
    return new Date().getTime().toString();
  }, []);
  var popupValue = usePopupState(_extends({
    popupId: popupId,
    variant: 'popover'
  }, popupState));

  var _useState = useState({
    top: 0,
    left: 0
  }),
      menuPosition = _useState[0],
      setMenuPosition = _useState[1];

  useImperativeHandle(ref, function () {
    return popupValue;
  }, [popupValue]);
  if (hide) return null;
  if (getContextMenu) return /*#__PURE__*/React.createElement(React.Fragment, null, getContextMenu(function openMenu(event) {
    event.preventDefault(); // @ts-ignore

    var left = (event == null ? void 0 : event.clientX) + 10; // @ts-ignore

    var top = (event == null ? void 0 : event.clientY) + 10;
    popupValue.setOpen(true, event);
    setMenuPosition({
      top: top,
      left: left
    });
    return {
      top: top,
      left: left
    };
  }), /*#__PURE__*/React.createElement(Popover, _extends({}, bindPopover(popupValue), {
    anchorReference: "anchorPosition",
    anchorPosition: menuPosition
  }, rest), children));
  if (!hover) return /*#__PURE__*/React.createElement(React.Fragment, null, button ? /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(classes.trigger, className),
    style: {
      width: fullWidth ? '100%' : 'unset'
    }
  }, bindTrigger(popupValue)), button) :
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(Button, _extends({}, buttonProps, bindTrigger(popupValue), {
    fullWidth: fullWidth
  }), label), /*#__PURE__*/React.createElement(Popover, _extends({}, bindPopover(popupValue), {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, rest), children));
  return /*#__PURE__*/React.createElement(React.Fragment, null, button ? /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(classes.trigger, className)
  }, bindHover(popupValue)), button) :
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(Button, _extends({}, buttonProps, bindHover(popupValue)), label), /*#__PURE__*/React.createElement(HoverPopover, _extends({}, bindPopover(popupValue), {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, rest, {
    disableRestoreFocus: true
  }), children));
});
export default /*#__PURE__*/memo(Popup);